import React, { useState, useEffect } from 'react'
import GridSearchTemplate from '../GridSearchTemplate'
import { Form } from 'semantic-ui-react'
import HotelsDropDown from '../../components/shared/HotelsDropDown'
import UsersDropDown from '../../components/shared/UsersDropDown'
import _ from 'lodash'
import { GetUsers } from '../../api/services/organization'
import PropTypes from 'prop-types'
import { MenuActions } from '../../components/shared/constants'
import { onSuccess, onWarning } from '../../components/shared/messages'
import { ETL } from '../../api/services/next'

const AnalyticsUserMapping = () => {
    const [hotels, setHotels] = useState([])
    const [gridData, setGridData] = useState([])

    useEffect(() => {
        (async () => {
            const data = await ETL.GetHotels({});
            setHotels(data)
        })()
    }, [])


    useEffect(() => {
        if (window.optima.commands) {
            window.optima.commands.unsubscribe(MenuActions.save)
            window.optima.commands.subscribe(MenuActions.save, save);
        }
    }, [gridData])

    const save = () => {
        var duplicated = checkValue(gridData);
        if (duplicated != "") {
            onWarning(window.optima.resourceManager.messages.UnableToSaveAnalytics + duplicated);
            return;
        }
        (async () => { 
          await ETL.SaveOrUpdateAnalyticsUsers({ request: gridData }); 
        })();
        onSuccess()
    }

    function checkValue(arr) {
        var status = "";

        for (var i = 0; i < arr.length; i++) {
            for (var j = 0; j < i; j++) {
                if (arr[i].PyramidUserName.toUpperCase() == arr[j].PyramidUserName.toUpperCase() && i != j) {
                    status = arr[i].PyramidUserName;
                    break;
                }
            }
        }

        return status;
    }

    const onSearchComplete = data => {
        const newArr = data.map(v => ({ ...v, IsSaved: true }))
        setGridData(newArr);
    }

    const onGridUpdate = (added, changed, deleted) => {
        let updated = [...gridData]
        if (added){
            updated = [...updated, ...added]
        }

        if (changed) {
            _.forEach(changed, (value, key) => {
                if (value) {
                    _.forEach(value, (newValue, prop) => {
                        switch (prop) {
                            case "UserHotels":
                                updated[key][prop] = _.map(newValue, HotelID => {
                                    const hotel = hotels.find(x => x.Id == HotelID)
                                    return {
                                        HotelID: hotel.Id,
                                        HotelName: hotel.Name,
                                        HotelChainID: hotel.HotelChainID
                                    }
                                })
                                break;
                            case "User":
                                (async () => {

                                    var spec = _.reduce(newValue, (result, id, index) => {
                                        result["IDs[" + index + "]"] = id
                                        return result
                                    }, {});
                                    spec.SkipChainCheck = true;
                                    const users = await GetUsers(spec);
                                    updated[key][prop] = users;
                                })()


                                break;

                            default:
                                updated[key][prop] = newValue
                        }

                    })
                }
            })
            if (deleted) {
                updated = updated.filter((x, i)=>!deleted.includes(i))
            }
            setGridData(updated);
        }
    }

    const customPropsCallback = item => {
        return {
            spec: _.reduce(item.UserHotels, (result, hotel, index) => {

                const hotelFromList = _.find(hotels, ["ID", hotel.HotelID]);


                if (hotelFromList.HotelChainID) {
                    result["ChainIDs[" + index + "]"] = hotelFromList.HotelChainID
                }

                return result
            }, {})
        }
    }

    const MyInput = ({ onChange, ...rest }) => {
        return <Form.Input onChange={(e, { value }) => onChange(value)} {...rest} />
    }
    MyInput.propTypes = {
        onChange: PropTypes.func
    }

    const gridOptions = {
        search: {
            title: "Analytics User Mapping",
            description: "Providing PMS User's mapping to Report System's Users",
            fields: [
                <MyInput label="User" key="UserName" />
            ],
            api: ETL.GetAnalyticsUsers, // passing API as parameter ,
            searchOnLoad: true
        },
        grid: {
            columns: [
                { name: 'PyramidUserName', title: 'Pyramid UserName' },
                { name: 'UserHotels', title: 'Hotels', displayField: "HotelName", valueField: "HotelID", editor: <HotelsDropDown fluid search multiple data={hotels} /> },
                { name: 'User', title: 'Users', displayField: "UserName", valueField: "Id", customProps: customPropsCallback, editor: <UsersDropDown fluid search multiple /> },
            ],
            editable: {
                allowAdd: true,
                allowDelete: true
            }
        }
    }
    return <div style={{ flexDirection: "column" }}>
        <GridSearchTemplate options={gridOptions} onGridUpdate={onGridUpdate} onSearchComplete={onSearchComplete} data={gridData} />
    </div>
}

export default AnalyticsUserMapping
